import { useQuery, gql, TypedDocumentNode } from '@apollo/client';
import React from 'react';
import { Constrain, Stack, Text } from '@moda/om';
import {
  SoldOutProductRecommendationsQuery,
  SoldOutProductRecommendationsQueryVariables
} from '../../generated/types';
import { useSimilarProducts } from '../../hooks/useRecommendations';
import { CAROUSEL_DEFAULT_CONFIG, SwiperCarousel } from '../Swiper';
import { useModuleTracking } from '../../hooks/useModuleTracking';
import { VariantCell } from '../Grid/GridCell/VariantCell';

import './SoldOutProductRecommendations.scss';

interface Props {
  variantId: string;
}

export const SOLD_OUT_PRODUCT_RECOMMENDATIONS_QUERY: TypedDocumentNode<
  SoldOutProductRecommendationsQuery,
  SoldOutProductRecommendationsQueryVariables
> = gql`
  query SoldOutProductRecommendationsQuery($variantId: String!) {
    variant(id: $variantId) {
      id
      name
      designer_name
    }
  }
`;

export const SoldOutProductRecommendations: React.FC<Props> = ({ variantId }) => {
  const variantQuery = useQuery(SOLD_OUT_PRODUCT_RECOMMENDATIONS_QUERY, {
    variables: { variantId }
  });

  const recsQuery = useSimilarProducts({ variantId });

  const { ref } = useModuleTracking({
    name: 'Sold Out Item Recommendations Carousel',
    variants: recsQuery.variants
  });

  if (!variantQuery.data?.variant || recsQuery.variants.length === 0) return null;

  return (
    <section ref={ref} className="SoldOutProductRecommendations">
      <Constrain>
        <Stack space={3}>
          <Text family="serif" treatment="h3">
            {variantQuery.data.variant.designer_name} {variantQuery.data.variant.name} is{' '}
            <Text color="code-red" family="serif" treatment="h3">
              sold out
            </Text>
          </Text>
          <Text treatment="body1">SHOP SIMILAR ITEMS</Text>

          <SwiperCarousel
            {...CAROUSEL_DEFAULT_CONFIG}
            identifier={`SoldOutProductRecommendations-${variantId}`}
          >
            {recsQuery.variants.map(
              variant => variant && <VariantCell key={variant.id} variant={variant} />
            )}
          </SwiperCarousel>
        </Stack>
      </Constrain>
    </section>
  );
};
